import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { InventoryApiResponse } from '../interfaces/InventoryDashboardInterfaces';
import { TabKeys } from '../components/InventoryView/InventoryViewConstants';

export interface SlotConfig {
  // Typed as TabKeys (not string) so SLOT_CONFIGS stays compile-time in sync with the dashboard tabs.
  key: TabKeys;
  sheetName: string;
  fetchFn: (
    api: ApiClient,
    artEventId: string | null | undefined
  ) => Promise<InventoryApiResponse | null>;
}

/**
 * Common column headers for the export Excel sheets.
 * Matches the segment data fields displayed in the dashboard tabs.
 */
export const EXPORT_HEADERS = [
  'Segment Name',
  'Total Impressions',
  'Overall Value',
  '% Consumed',
  '% Available',
  'CPM',
  'Type of Purchase',
  'Category',
];
